import { DateTime, Duration } from 'luxon'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowUp, faCheck, faClipboardListCheck, faWrench,
} from '@fortawesome/pro-light-svg-icons'

import { Box, NumberWithIconGrid, Text } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import useChartData from '@hooks/useChartData'

import { TaskListModel } from '@domain-group/realhub-backend-api-types'

type ProjectOverviewProps = {
  taskList: TaskListModel,
}

const ProjectOverview = (props:ProjectOverviewProps) => {
  const { taskList } = props

  const chartDataPayload = useChartData('template_project_overview', {
    entityId: taskList.id,
    entityType: 'TaskList',
  })

  const { dataPayload, loading } = chartDataPayload

  const data = digObject(dataPayload, 'data', {})
  const {
    average_tasks_completed_per_day,
    average_tasks_created_per_day,
    estimated_completion_date,
  } = data

  const avgBuildTime = digObject(data, 'sub_task_averages.build.average_creation_to_completion_time', 0)
  const avgInternalQcTime = digObject(data, 'sub_task_averages.qc_internal.average_creation_to_completion_time', 0)

  const {
    // @ts-expect-error TS2339
    values: { hours: buildHours, minutes: buildMinutes },
  } = Duration.fromObject({ seconds: avgBuildTime }).shiftTo('hours', 'minutes')

  const {
    // @ts-expect-error TS2339
    values: { hours: qcHours, minutes: qcMinutes },
  } = Duration.fromObject({ seconds: avgInternalQcTime }).shiftTo('hours', 'minutes')

  return (
    <Box
      backgroundColor="white"
      border="1px solid"
      borderRadius={5}
      borderColor="lineColor"
      flexDirection="column"
    >
      {!loading && (
        <Box flexDirection="column">
          <Box borderBottom="1px solid" borderColor="lineColor" flexDirection="column" padding="large">
            <Text color="bodyFontLightColor" fontSize="xsmall">
              Estimated Completion
            </Text>

            <Text marginTop="medium">
              {estimated_completion_date
                ? DateTime.fromFormat(estimated_completion_date, 'dd/MM/yyyy').toFormat('ccc dd LLL yyyy')
                : ''}
            </Text>
          </Box>

          <NumberWithIconGrid>
            <NumberWithIconGrid.Item
              disableHover
              icon={<FontAwesomeIcon icon={faArrowUp} />}
              label="Created per Day"
              value={average_tasks_created_per_day}
            />

            <NumberWithIconGrid.Item
              disableHover
              icon={<FontAwesomeIcon icon={faCheck} />}
              label="Completed per Day"
              value={average_tasks_completed_per_day}
            />

            <NumberWithIconGrid.Item
              disableHover
              icon={<FontAwesomeIcon icon={faWrench} />}
              label="Build Time"
              value={
                buildHours > 0
                  ? `${buildHours}h ${buildMinutes.toFixed(2)}m`
                  : `${buildMinutes.toFixed(2)}m`
              }
            />

            <NumberWithIconGrid.Item
              disableHover
              icon={<FontAwesomeIcon icon={faClipboardListCheck} />}
              label="Internal QC Time"
              value={
                qcHours > 0
                  ? `${qcHours}h ${qcMinutes.toFixed(2)}m`
                  : `${qcMinutes.toFixed(2)}m`
              }
            />
          </NumberWithIconGrid>
        </Box>
      )}
    </Box>
  )
}

export default ProjectOverview
